import { useEffect, useMemo } from 'react'
import { Stack, Typography } from '@mui/material'
import { Field, Logger } from '@wolfdanepug/common-react'
import { SegmentComponentProps } from '../types'
import { foodTypeOptions, treatsOptions } from '../context/onboarding/options'

export default function Diet({ data, setCanStepForward, isMobile }: SegmentComponentProps) {
	useEffect(() => {
		Logger.log('[Diet] data', data)
	}, [data])

	// the dog object
	const dog = useMemo(() => {
		const key = data?.dogs?.[data.activeDogContext]
		if (!key) return undefined
		const dogData = data?.dog[key]
		return dogData
	}, [data])

	// the dog gender context
	const genderContext = useMemo(() => {
		return dog?.gender === 'male' ? 'he' : 'she'
	}, [dog?.gender])

	useEffect(() => {
		dog?.currentMealType && dog?.treats && setCanStepForward(true)
	}, [dog])

	return (
		<>
			<Stack direction={isMobile ? 'column' : 'row'} alignItems="center" gap={2}>
				<Stack direction={'row'} alignItems={'center'} gap={2}>
					<Typography whiteSpace="nowrap">{genderContext} mainly eats</Typography>
					<Field
						name={['currentMealType', 'dog']}
						defaultValue={dog?.currentMealType || ''}
						type="select"
						variant="standard"
						options={foodTypeOptions}
						defaultOptionLabel="Select"
					/>
				</Stack>
				<Stack direction={'row'} alignItems={'center'} gap={2}>
					<Typography whiteSpace="nowrap">and gets</Typography>

					<Field
						name={['treats', 'dog']}
						defaultValue={dog?.treats || ''}
						type="select"
						variant="standard"
						options={treatsOptions}
						defaultOptionLabel="Select"
						onChange={() => setCanStepForward(true)}
					/>

					<Typography>treats</Typography>
				</Stack>
			</Stack>
		</>
	)
}
